import {useNavigate} from 'react-router-dom'
import {Input} from 'antd'

import {Button, Form, FormItem} from 'common/components'
import {EMAIL_FIELD_RULES} from 'common/constants'
import {useResetPassword} from '..'

export default function PasswordResetForm() {
  const navigate = useNavigate()
  const {mutate: resetPassword, isMutating} = useResetPassword(() =>
    navigate('/login')
  )

  const handleFinish = (values: any) => {
    resetPassword(values)
  }

  return (
    <Form onFinish={handleFinish}>
      <FormItem name="email" label="Email" rules={EMAIL_FIELD_RULES}>
        <Input autoFocus />
      </FormItem>
      <Button block htmlType="submit" loading={isMutating}>
        Reset password
      </Button>
    </Form>
  )
}
